// extracted by mini-css-extract-plugin
export const header = "L_bV";
export const searchBtn = "L_bW";
export const toolbar = "L_bX";
export const appIcon = "L_bY";
export const space = "L_bh";